import styled, { css } from 'styled-components';
import { layout } from '@prisjakt/ui-base';
import Clickable from '@prisjakt/ui-clickable';
import {
  CaptionText,
  TitleSmallText,
  TitleMediumText,
} from '@prisjakt/ui/text/variants';
import { ExpertUserCardSize } from 'src/areas/expert/types';

export const USER_AVATAR_SIZE_SMALL = 32;
export const USER_AVATAR_SIZE_MEDIUM = 48;

type NameProps = {
  $showSubtitle: boolean;
};

const sharedStyles = css`
  align-self: center;
`;

export const NameMedium = styled(TitleMediumText)<NameProps>`
  ${sharedStyles};
  grid-area: ${p => (p.$showSubtitle ? '1 / 2 / 2 / 3' : '1 / 2 / 3 / 3')};
`;

export const NameSmall = styled(TitleSmallText)<NameProps>`
  ${sharedStyles};
  grid-area: ${p => (p.$showSubtitle ? '1 / 2 / 2 / 3' : '1 / 2 / 3 / 3')};
`;

type SubtitleProps = {
  $size: ExpertUserCardSize;
};

export const Subtitle = styled(CaptionText)<SubtitleProps>(
  props => css`
    font-size: ${props.$size === ExpertUserCardSize.MEDIUM
      ? layout.measurements.fontSizeNormal
      : layout.measurements.fontSizeSmall};
  `
);

export const Avatar = styled.div`
  grid-area: 1 / 1 / 3 / 2;
  align-self: center;
`;

type ExpertProps = {
  $index: number;
  $overlap: number;
  $size: number;
};

export const Expert = styled.div<ExpertProps>(
  props => css`
    display: grid;
    grid-template-columns: ${props.$size}px 1fr;
    grid-template-rows: auto auto;
    column-gap: ${layout.measurements.spacing050};
    transform: ${props.$overlap
      ? `translateX(-${(props.$size * props.$overlap) / 2}px)`
      : 'none'};
    z-index: ${props.$index};

    p {
      margin: 0;
    }
  `
);

type ContainerProps = { $size: number; $pointer: boolean };

export const Container = styled(Clickable)<ContainerProps>(
  props => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    ${props.$pointer ? 'cursor: pointer;' : ''}
    cursor: pointer;
    max-height: ${props.$size}px;

    &[href]:hover {
      ${NameMedium} {
        color: ${props.theme.text.callToActionHover};
      }
      ${NameSmall} {
        color: ${props.theme.text.callToActionHover};
      }
    }
  `
);
